import _ from 'lodash'
import { getDepartment } from 'shared-js/menu-services/departments-service'
import { getItem } from 'shared-js/menu-services/items-service'
import { getStyleOption } from 'shared-js/menu-services/department-styles-service'
import { getModifierCategory, getModifierItem } from 'shared-js/menu-services/modifiers-service'
import { isOrderTypeActive } from 'shared-js/settings-services/order-types-service'
import { getCategory } from 'shared-js/menu-services/categories-service'

export function cleanLayoutTabs (layout, menuBlob, settingsBlob) {
  for (const tab of _.values(_.get(layout, 'tabs', {}))) {
    cleanLayoutTab(tab, menuBlob, settingsBlob)
  }
}

export function cleanLayoutTab (tab, menuBlob, settingsBlob) {
  for (const button of _.values(_.get(tab, 'buttons', {}))) {
    cleanItemInfo(button, tab, menuBlob)
    cleanModifierInfo(button, tab, menuBlob)
    cleanSizeInfo(button, tab, menuBlob)
    cleanStyleInfo(button, tab, menuBlob)
    cleanMessageInfo(button, tab, menuBlob)
    cleanTenderInfo(button, tab, settingsBlob)
    cleanMenuLinkInfo(button, tab, menuBlob)
    cleanSpecialFunctionInfo(button, menuBlob)
    cleanOfferInfo(button, tab, menuBlob)
  }
}

function cleanItemInfo (button, tab, menuBlob) {
  const info = _.get(button, 'typeInfo.itemInfo', {})

  if (!getDepartment(info.departmentId, menuBlob) || !getItem(info.itemId, info.departmentId, menuBlob)) {
    if (button.type === 'ITEM') {
      delete tab.buttons[button.index]
    } else {
      nullOut(info)
    }

    return
  }

  cleanStyleAndLink(info, menuBlob)
}

function cleanModifierInfo (button, tab, menuBlob) {
  const info = _.get(button, 'typeInfo.modifierInfo', {})

  if (!getModifierItem(info.modifierItemId, menuBlob) || !getModifierCategory(info.modifierCategoryId, menuBlob)) {
    if (button.type === 'MODIFIER') {
      delete tab.buttons[button.index]
    } else {
      nullOut(info)
    }

    return
  }

  if (!getDepartment(info.departmentId, menuBlob)) {
    info.departmentId = null
  }

  cleanStyleAndLink(info, menuBlob)
}

function cleanStyleAndLink (info, menuBlob) {
  if (info.sizeOptionId && !getStyleOption(info.departmentId, info.sizeId, info.sizeOptionId, menuBlob)) {
    info.sizeId = null
    info.sizeOptionId = null
  }

  if (info.styleOptionId && !getStyleOption(info.departmentId, info.styleId, info.styleOptionId, menuBlob)) {
    info.styleId = null
    info.styleOptionId = null
  }

  if (info.menuLinkId && !menuBlob.layout.tabs.hasOwnProperty(info.menuLinkId)) {
    info.menuLinkId = null
  }
}

function cleanSizeInfo (button, tab, menuBlob) {
  const info = _.get(button, 'typeInfo.sizeInfo', {})
  if (!getStyleOption(info.departmentId, info.sizeId, info.sizeOptionId, menuBlob)) {
    if (button.type === 'SIZE') {
      delete tab.buttons[button.index]
    } else {
      nullOut(info)
    }
  }
}

function cleanStyleInfo (button, tab, menuBlob) {
  const info = _.get(button, 'typeInfo.styleInfo', {})
  if (!getStyleOption(info.departmentId, info.styleId, info.styleOptionId, menuBlob)) {
    if (button.type === 'STYLE') {
      delete tab.buttons[button.index]
    } else {
      nullOut(info)
    }
  }
}

function cleanMessageInfo (button, tab, menuBlob) {
  const messageId = _.get(button, 'typeInfo.messageId')
  const message = _.get(menuBlob, 'messages', []).find(it => it.id === messageId)

  if (!message) {
    if (button.type === 'MESSAGE') {
      delete tab.buttons[button.index]
    } else {
      button.typeInfo.messageId = null
    }
  }
}

function cleanTenderInfo (button, tab, settingsBlob) {
  const info = _.get(button, 'typeInfo.tenderInfo', {})
  const tenderType = _.get(settingsBlob, 'tenderTypes', []).find(it => it.id === info.tenderTypeId)

  if (!tenderType) {
    if (button.type === 'TENDER') {
      delete tab.buttons[button.index]
    } else {
      nullOut(info)
    }
    return
  }

  if (info.orderType && !isOrderTypeActive(info.orderType, settingsBlob)) {
    info.orderType = null
  }
}

function cleanMenuLinkInfo (button, tab, menuBlob) {
  const menuLinkId = _.get(button, 'typeInfo.menuLinkId')

  if (!menuBlob.layout.tabs.hasOwnProperty(menuLinkId)) {
    if (button.type === 'MENU_LINK') {
      delete tab.buttons[button.index]
    } else {
      button.typeInfo.menuLinkId = null
    }
  }
}

function cleanSpecialFunctionInfo (button, menuBlob) {
  if (_.isNil(_.get(button, 'typeInfo.specialFunctionInfo.itemSearch.categoryId'))) {
    return
  }

  const itemSearch = button.typeInfo.specialFunctionInfo.itemSearch
  if (!getCategory(itemSearch.categoryId, itemSearch.departmentId, menuBlob)) {
    itemSearch.departmentId = null
    itemSearch.categoryId = null
    itemSearch.restrictToCategory = false
  }
}

function cleanOfferInfo (button, tab, menuBlob) {
  const info = _.get(button, 'typeInfo.offerInfo', {})
  const offer = _.get(menuBlob, 'offers', []).find(it => it.id === info.offerId)
  if (!offer) {
    if (button.type === 'OFFER') {
      delete tab.buttons[button.index]
    } else {
      nullOut(info)
    }
  }
}

function nullOut (info) {
  for (const key of Object.keys(info)) {
    info[key] = key === 'showImage' ? false : null
  }
}
